import { useState, useEffect } from "react";

export const useResponsiveLayout = () => {
  const MOBILE_WIDTH = 640;

  const [isDesktop, setIsDesktop] = useState(
    window.innerWidth > MOBILE_WIDTH
  );

  useEffect(() => {
    const init = () => {
      if (window.innerWidth > MOBILE_WIDTH) {
        setIsDesktop(true);
      } else {
        setIsDesktop(false);
      }
    };
    init();
    window.addEventListener("resize", init);
    return () => window.removeEventListener("resize", init);
  }, []);

  return { isDesktop };
}